import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Optional, Inject, NgModule, SkipSelf } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders, HttpContext, HttpParams } from '@angular/common/http';

/**
 * Custom HttpParameterCodec
 * Workaround for https://github.com/angular/angular/issues/18261
 */
class CustomHttpParameterCodec {
  encodeKey(k) {
    return encodeURIComponent(k);
  }
  encodeValue(v) {
    return encodeURIComponent(v);
  }
  decodeKey(k) {
    return decodeURIComponent(k);
  }
  decodeValue(v) {
    return decodeURIComponent(v);
  }
}
const BASE_PATH = new InjectionToken('basePath');
const COLLECTION_FORMATS = {
  'csv': ',',
  'tsv': '   ',
  'ssv': ' ',
  'pipes': '|'
};
class ShopConfiguration {
  /**
   *  @deprecated Since 5.0. Use credentials instead
   */
  apiKeys;
  username;
  password;
  /**
   *  @deprecated Since 5.0. Use credentials instead
   */
  accessToken;
  basePath;
  withCredentials;
  /**
   * Takes care of encoding query- and form-parameters.
   */
  encoder;
  /**
   * Encoding of various path parameter
   * <a href="https://github.com/OAI/OpenAPI-Specification/blob/main/versions/3.1.0.md#style-values">styles</a>.
   * <p>
   * See {@link README.md} for more details
   * </p>
   */
  encodeParam;
  /**
   * The keys are the names in the securitySchemes section of the OpenAPI
   * document. They should map to the value used for authentication
   * minus any standard prefixes such as 'Basic' or 'Bearer'.
   */
  credentials;
  defaultHeaders;
  constructor(configurationParameters = {}) {
    this.apiKeys = configurationParameters.apiKeys;
    this.username = configurationParameters.username;
    this.password = configurationParameters.password;
    this.accessToken = configurationParameters.accessToken;
    this.basePath = configurationParameters.basePath;
    this.withCredentials = configurationParameters.withCredentials;
    this.encoder = configurationParameters.encoder;
    this.defaultHeaders = configurationParameters.defaultHeaders;
    if (configurationParameters.encodeParam) {
      this.encodeParam = configurationParameters.encodeParam;
    } else {
      this.encodeParam = param => this.defaultEncodeParam(param);
    }
    if (configurationParameters.credentials) {
      this.credentials = configurationParameters.credentials;
    } else {
      this.credentials = {};
    }
    // init default Bearer credential
    if (!this.credentials['Bearer']) {
      this.credentials['Bearer'] = () => {
        return typeof this.accessToken === 'function' ? this.accessToken() : this.accessToken;
      };
    }
  }
  /**
   * Select the correct content-type to use for a request.
   * Uses {@link ShopConfiguration#isJsonMime} to determine the correct content-type.
   * If no content type is found return the first found type if the contentTypes is not empty
   * @param contentTypes - the array of content types that are available for selection
   * @returns the selected content-type or <code>undefined</code> if no selection could be made.
   */
  selectHeaderContentType(contentTypes) {
    if (contentTypes.length === 0) {
      return undefined;
    }
    const type = contentTypes.find(x => this.isJsonMime(x));
    if (type === undefined) {
      return contentTypes[0];
    }
    return type;
  }
  /**
   * Select the correct accept content-type to use for a request.
   * Uses {@link ShopConfiguration#isJsonMime} to determine the correct accept content-type.
   * If no content type is found return the first found type if the contentTypes is not empty
   * @param accepts - the array of content types that are available for selection.
   * @returns the selected content-type or <code>undefined</code> if no selection could be made.
   */
  selectHeaderAccept(accepts) {
    if (accepts.length === 0) {
      return undefined;
    }
    const type = accepts.find(x => this.isJsonMime(x));
    if (type === undefined) {
      return accepts[0];
    }
    return type;
  }
  /**
   * Check if the given MIME is a JSON MIME.
   * JSON MIME examples:
   *   application/json
   *   application/json; charset=UTF8
   *   APPLICATION/JSON
   *   application/vnd.company+json
   * @param mime - MIME (Multipurpose Internet Mail Extensions)
   * @return True if the given MIME is JSON, false otherwise.
   */
  isJsonMime(mime) {
    const jsonMime = new RegExp('^(application\/json|[^;/ \t]+\/[^;/ \t]+[+]json)[ \t]*(;.*)?$', 'i');
    return mime !== null && (jsonMime.test(mime) || mime.toLowerCase() === 'application/json-patch+json');
  }
  lookupCredential(key) {
    const value = this.credentials[key];
    return typeof value === 'function' ? value() : value;
  }
  defaultEncodeParam(param) {
    // This implementation exists as fallback for missing configuration
    // and for backwards compatibility to older typescript-angular generator versions.
    // It only works for the 'simple' parameter style.
    // Date-handling only works for the 'date-time' format.
    // All other styles and Date-formats are probably handled incorrectly.
    //
    // But: if that's all you need (i.e.: the most common use-case): no need for customization!
    const value = param.dataFormat === 'date-time' && param.value instanceof Date ? param.value.toISOString() : param.value;
    return encodeURIComponent(String(value));
  }
}

/**
 * ESD ShoppingApiGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 121.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let ArticleConfigurationService = /*#__PURE__*/(() => {
  class ArticleConfigurationService {
    httpClient;
    basePath = 'https://api.esders.de/shop/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ShopConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    getConfigData(articleNumber, language, observe = 'body', reportProgress = false, options) {
      if (articleNumber === null || articleNumber === undefined) {
        throw new Error('Required parameter articleNumber was null or undefined when calling getConfigData.');
      }
      if (language === null || language === undefined) {
        throw new Error('Required parameter language was null or undefined when calling getConfigData.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/articleconfiguration/${this.configuration.encodeParam({
        name: "articleNumber",
        value: articleNumber,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/${this.configuration.encodeParam({
        name: "language",
        value: language,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    validateConfigData(configData, observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/articleconfiguration/validate`;
      return this.httpClient.request('put', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: configData,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function ArticleConfigurationService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ArticleConfigurationService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ShopConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ArticleConfigurationService,
      factory: ArticleConfigurationService.ɵfac,
      providedIn: 'root'
    });
  }
  return ArticleConfigurationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * ESD ShoppingApiGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 121.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let BrochuresService = /*#__PURE__*/(() => {
  class BrochuresService {
    httpClient;
    basePath = 'https://api.esders.de/shop/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ShopConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    getBrochurePdf(brochureId, name, observe = 'body', reportProgress = false, options) {
      if (brochureId === null || brochureId === undefined) {
        throw new Error('Required parameter brochureId was null or undefined when calling getBrochurePdf.');
      }
      if (name === null || name === undefined) {
        throw new Error('Required parameter name was null or undefined when calling getBrochurePdf.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = [];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/brochures/${this.configuration.encodeParam({
        name: "brochureId",
        value: brochureId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}/${this.configuration.encodeParam({
        name: "name",
        value: name,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function BrochuresService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BrochuresService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ShopConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: BrochuresService,
      factory: BrochuresService.ɵfac,
      providedIn: 'root'
    });
  }
  return BrochuresService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * ESD ShoppingApiGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 121.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let CatalogPhotoService = /*#__PURE__*/(() => {
  class CatalogPhotoService {
    httpClient;
    basePath = 'https://api.esders.de/shop/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ShopConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    getCatalogPhotoByArticle(articleId, width, observe = 'body', reportProgress = false, options) {
      if (articleId === null || articleId === undefined) {
        throw new Error('Required parameter articleId was null or undefined when calling getCatalogPhotoByArticle.');
      }
      let localVarQueryParameters = new HttpParams({
        encoder: this.encoder
      });
      if (width !== undefined && width !== null) {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, width, 'width');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = [];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/catalogphoto/${this.configuration.encodeParam({
        name: "articleId",
        value: articleId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getCatalogPhotoByIdAndName(photoId, name, width, observe = 'body', reportProgress = false, options) {
      if (photoId === null || photoId === undefined) {
        throw new Error('Required parameter photoId was null or undefined when calling getCatalogPhotoByIdAndName.');
      }
      if (name === null || name === undefined) {
        throw new Error('Required parameter name was null or undefined when calling getCatalogPhotoByIdAndName.');
      }
      let localVarQueryParameters = new HttpParams({
        encoder: this.encoder
      });
      if (width !== undefined && width !== null) {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, width, 'width');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = [];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/catalogphoto/${this.configuration.encodeParam({
        name: "photoId",
        value: photoId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}/${this.configuration.encodeParam({
        name: "name",
        value: name,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function CatalogPhotoService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CatalogPhotoService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ShopConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CatalogPhotoService,
      factory: CatalogPhotoService.ɵfac,
      providedIn: 'root'
    });
  }
  return CatalogPhotoService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * ESD ShoppingApiGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 121.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let FeatureService = /*#__PURE__*/(() => {
  class FeatureService {
    httpClient;
    basePath = 'https://api.esders.de/shop/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ShopConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    getFeatures(language, observe = 'body', reportProgress = false, options) {
      if (language === null || language === undefined) {
        throw new Error('Required parameter language was null or undefined when calling getFeatures.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/feature/${this.configuration.encodeParam({
        name: "language",
        value: language,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function FeatureService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FeatureService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ShopConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FeatureService,
      factory: FeatureService.ɵfac,
      providedIn: 'root'
    });
  }
  return FeatureService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * ESD ShoppingApiGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 121.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let HompageSearchService = /*#__PURE__*/(() => {
  class HompageSearchService {
    httpClient;
    basePath = 'https://api.esders.de/shop/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ShopConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    searchByFeatureFilter(page, maxItemPerPage, homepagePropertySearch, observe = 'body', reportProgress = false, options) {
      if (page === null || page === undefined) {
        throw new Error('Required parameter page was null or undefined when calling searchByFeatureFilter.');
      }
      if (maxItemPerPage === null || maxItemPerPage === undefined) {
        throw new Error('Required parameter maxItemPerPage was null or undefined when calling searchByFeatureFilter.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/hompagesearch/${this.configuration.encodeParam({
        name: "page",
        value: page,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}/${this.configuration.encodeParam({
        name: "maxItemPerPage",
        value: maxItemPerPage,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}/filter`;
      return this.httpClient.request('post', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: homepagePropertySearch,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    searchByFeatureList(featureId, page, maxItemPerPage, language, observe = 'body', reportProgress = false, options) {
      if (featureId === null || featureId === undefined) {
        throw new Error('Required parameter featureId was null or undefined when calling searchByFeatureList.');
      }
      if (page === null || page === undefined) {
        throw new Error('Required parameter page was null or undefined when calling searchByFeatureList.');
      }
      if (maxItemPerPage === null || maxItemPerPage === undefined) {
        throw new Error('Required parameter maxItemPerPage was null or undefined when calling searchByFeatureList.');
      }
      if (language === null || language === undefined) {
        throw new Error('Required parameter language was null or undefined when calling searchByFeatureList.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/hompagesearch/${this.configuration.encodeParam({
        name: "featureId",
        value: featureId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}/${this.configuration.encodeParam({
        name: "page",
        value: page,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}/${this.configuration.encodeParam({
        name: "maxItemPerPage",
        value: maxItemPerPage,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}/${this.configuration.encodeParam({
        name: "language",
        value: language,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    searchHomepage(page, maxItemPerPage, language, value, type, observe = 'body', reportProgress = false, options) {
      if (page === null || page === undefined) {
        throw new Error('Required parameter page was null or undefined when calling searchHomepage.');
      }
      if (maxItemPerPage === null || maxItemPerPage === undefined) {
        throw new Error('Required parameter maxItemPerPage was null or undefined when calling searchHomepage.');
      }
      let localVarQueryParameters = new HttpParams({
        encoder: this.encoder
      });
      if (language !== undefined && language !== null) {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, language, 'language');
      }
      if (value !== undefined && value !== null) {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, value, 'value');
      }
      if (type !== undefined && type !== null) {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, type, 'type');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/hompagesearch/${this.configuration.encodeParam({
        name: "page",
        value: page,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}/${this.configuration.encodeParam({
        name: "maxItemPerPage",
        value: maxItemPerPage,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function HompageSearchService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HompageSearchService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ShopConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: HompageSearchService,
      factory: HompageSearchService.ɵfac,
      providedIn: 'root'
    });
  }
  return HompageSearchService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * ESD ShoppingApiGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 121.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let OrderService = /*#__PURE__*/(() => {
  class OrderService {
    httpClient;
    basePath = 'https://api.esders.de/shop/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ShopConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    getOrderDetailsById(orderId, language, observe = 'body', reportProgress = false, options) {
      if (orderId === null || orderId === undefined) {
        throw new Error('Required parameter orderId was null or undefined when calling getOrderDetailsById.');
      }
      if (language === null || language === undefined) {
        throw new Error('Required parameter language was null or undefined when calling getOrderDetailsById.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/order/${this.configuration.encodeParam({
        name: "orderId",
        value: orderId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/${this.configuration.encodeParam({
        name: "language",
        value: language,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getOrderDetailsByToken(orderNumber, language, token, observe = 'body', reportProgress = false, options) {
      if (orderNumber === null || orderNumber === undefined) {
        throw new Error('Required parameter orderNumber was null or undefined when calling getOrderDetailsByToken.');
      }
      if (language === null || language === undefined) {
        throw new Error('Required parameter language was null or undefined when calling getOrderDetailsByToken.');
      }
      if (token === null || token === undefined) {
        throw new Error('Required parameter token was null or undefined when calling getOrderDetailsByToken.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/order/${this.configuration.encodeParam({
        name: "orderNumber",
        value: orderNumber,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/${this.configuration.encodeParam({
        name: "language",
        value: language,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/${this.configuration.encodeParam({
        name: "token",
        value: token,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getOrderList(orderSearch, observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/order`;
      return this.httpClient.request('post', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: orderSearch,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getOrderListCsv(orderSearch, observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/octet-stream'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let localVarPath = `/order/csv`;
      return this.httpClient.request('post', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: orderSearch,
        responseType: "blob",
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function OrderService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ShopConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: OrderService,
      factory: OrderService.ɵfac,
      providedIn: 'root'
    });
  }
  return OrderService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * ESD ShoppingApiGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 121.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let ProductPageService = /*#__PURE__*/(() => {
  class ProductPageService {
    httpClient;
    basePath = 'https://api.esders.de/shop/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ShopConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    getLivePage(articleNumber, language, observe = 'body', reportProgress = false, options) {
      if (articleNumber === null || articleNumber === undefined) {
        throw new Error('Required parameter articleNumber was null or undefined when calling getLivePage.');
      }
      if (language === null || language === undefined) {
        throw new Error('Required parameter language was null or undefined when calling getLivePage.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/productpage/${this.configuration.encodeParam({
        name: "articleNumber",
        value: articleNumber,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/${this.configuration.encodeParam({
        name: "language",
        value: language,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function ProductPageService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductPageService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ShopConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ProductPageService,
      factory: ProductPageService.ɵfac,
      providedIn: 'root'
    });
  }
  return ProductPageService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * ESD ShoppingApiGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 121.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let SalesArticleService = /*#__PURE__*/(() => {
  class SalesArticleService {
    httpClient;
    basePath = 'https://api.esders.de/shop/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ShopConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    getArticleInfo(articleNo, language, observe = 'body', reportProgress = false, options) {
      if (articleNo === null || articleNo === undefined) {
        throw new Error('Required parameter articleNo was null or undefined when calling getArticleInfo.');
      }
      if (language === null || language === undefined) {
        throw new Error('Required parameter language was null or undefined when calling getArticleInfo.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/salesarticle/${this.configuration.encodeParam({
        name: "articleNo",
        value: articleNo,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/${this.configuration.encodeParam({
        name: "language",
        value: language,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getPriceInfo(articleId, amount, observe = 'body', reportProgress = false, options) {
      if (articleId === null || articleId === undefined) {
        throw new Error('Required parameter articleId was null or undefined when calling getPriceInfo.');
      }
      if (amount === null || amount === undefined) {
        throw new Error('Required parameter amount was null or undefined when calling getPriceInfo.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/salesarticle/${this.configuration.encodeParam({
        name: "articleId",
        value: articleId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/${this.configuration.encodeParam({
        name: "amount",
        value: amount,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}/priceinfo`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function SalesArticleService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SalesArticleService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ShopConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SalesArticleService,
      factory: SalesArticleService.ɵfac,
      providedIn: 'root'
    });
  }
  return SalesArticleService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * ESD ShoppingApiGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 121.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let SalesOfferService = /*#__PURE__*/(() => {
  class SalesOfferService {
    httpClient;
    basePath = 'https://api.esders.de/shop/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ShopConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    cancelOffer(salesOfferId, observe = 'body', reportProgress = false, options) {
      if (salesOfferId === null || salesOfferId === undefined) {
        throw new Error('Required parameter salesOfferId was null or undefined when calling cancelOffer.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = [];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/salesoffer/${this.configuration.encodeParam({
        name: "salesOfferId",
        value: salesOfferId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('delete', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    checkSalesOfferAuth(salesOfferNumber, token, observe = 'body', reportProgress = false, options) {
      if (salesOfferNumber === null || salesOfferNumber === undefined) {
        throw new Error('Required parameter salesOfferNumber was null or undefined when calling checkSalesOfferAuth.');
      }
      if (token === null || token === undefined) {
        throw new Error('Required parameter token was null or undefined when calling checkSalesOfferAuth.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = [];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/salesoffer/${this.configuration.encodeParam({
        name: "salesOfferNumber",
        value: salesOfferNumber,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/${this.configuration.encodeParam({
        name: "token",
        value: token,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/auth`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getGCLIDCSV(observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['text/plain', 'application/json', 'text/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let localVarPath = `/salesoffer/gclid/csv`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: "blob",
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getSalesOfferByNumberAndToken(salesOfferNumber, token, observe = 'body', reportProgress = false, options) {
      let localVarQueryParameters = new HttpParams({
        encoder: this.encoder
      });
      if (salesOfferNumber !== undefined && salesOfferNumber !== null) {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, salesOfferNumber, 'salesOfferNumber');
      }
      if (token !== undefined && token !== null) {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, token, 'token');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/salesoffer`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getSalesOfferPdf(salesOfferId, observe = 'body', reportProgress = false, options) {
      if (salesOfferId === null || salesOfferId === undefined) {
        throw new Error('Required parameter salesOfferId was null or undefined when calling getSalesOfferPdf.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = [];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/salesoffer/${this.configuration.encodeParam({
        name: "salesOfferId",
        value: salesOfferId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/pdf`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getSalesOfferPdfWithToken(salesOfferNumber, token, observe = 'body', reportProgress = false, options) {
      if (salesOfferNumber === null || salesOfferNumber === undefined) {
        throw new Error('Required parameter salesOfferNumber was null or undefined when calling getSalesOfferPdfWithToken.');
      }
      if (token === null || token === undefined) {
        throw new Error('Required parameter token was null or undefined when calling getSalesOfferPdfWithToken.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = [];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/salesoffer/${this.configuration.encodeParam({
        name: "salesOfferNumber",
        value: salesOfferNumber,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/${this.configuration.encodeParam({
        name: "token",
        value: token,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/pdf`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    updateOffer(salesOfferId, salesOffer, observe = 'body', reportProgress = false, options) {
      if (salesOfferId === null || salesOfferId === undefined) {
        throw new Error('Required parameter salesOfferId was null or undefined when calling updateOffer.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = [];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/salesoffer/${this.configuration.encodeParam({
        name: "salesOfferId",
        value: salesOfferId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('put', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: salesOffer,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function SalesOfferService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SalesOfferService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ShopConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SalesOfferService,
      factory: SalesOfferService.ɵfac,
      providedIn: 'root'
    });
  }
  return SalesOfferService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * ESD ShoppingApiGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 121.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let ShoppingCartService = /*#__PURE__*/(() => {
  class ShoppingCartService {
    httpClient;
    basePath = 'https://api.esders.de/shop/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ShopConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    addConfiguratedArticleToCart(cookie, configData, observe = 'body', reportProgress = false, options) {
      if (cookie === null || cookie === undefined) {
        throw new Error('Required parameter cookie was null or undefined when calling addConfiguratedArticleToCart.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/shoppingcart/configuration/${this.configuration.encodeParam({
        name: "cookie",
        value: cookie,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('post', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: configData,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    addProductToCart(cookie, shoppingCartItem, observe = 'body', reportProgress = false, options) {
      if (cookie === null || cookie === undefined) {
        throw new Error('Required parameter cookie was null or undefined when calling addProductToCart.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/shoppingcart/${this.configuration.encodeParam({
        name: "cookie",
        value: cookie,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('post', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: shoppingCartItem,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    deletCartItem(cookie, cartItemId, observe = 'body', reportProgress = false, options) {
      if (cookie === null || cookie === undefined) {
        throw new Error('Required parameter cookie was null or undefined when calling deletCartItem.');
      }
      if (cartItemId === null || cartItemId === undefined) {
        throw new Error('Required parameter cartItemId was null or undefined when calling deletCartItem.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/shoppingcart/${this.configuration.encodeParam({
        name: "cookie",
        value: cookie,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/${this.configuration.encodeParam({
        name: "cartItemId",
        value: cartItemId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}`;
      return this.httpClient.request('delete', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getSchoppingCardCount(cookie, observe = 'body', reportProgress = false, options) {
      if (cookie === null || cookie === undefined) {
        throw new Error('Required parameter cookie was null or undefined when calling getSchoppingCardCount.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/shoppingcart/${this.configuration.encodeParam({
        name: "cookie",
        value: cookie,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getSchoppingCart(cookie, language, observe = 'body', reportProgress = false, options) {
      if (cookie === null || cookie === undefined) {
        throw new Error('Required parameter cookie was null or undefined when calling getSchoppingCart.');
      }
      if (language === null || language === undefined) {
        throw new Error('Required parameter language was null or undefined when calling getSchoppingCart.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/shoppingcart/${this.configuration.encodeParam({
        name: "cookie",
        value: cookie,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/${this.configuration.encodeParam({
        name: "language",
        value: language,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    orderShoppingCart(cookie, shoppingCart, observe = 'body', reportProgress = false, options) {
      if (cookie === null || cookie === undefined) {
        throw new Error('Required parameter cookie was null or undefined when calling orderShoppingCart.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/shoppingcart/${this.configuration.encodeParam({
        name: "cookie",
        value: cookie,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('put', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: shoppingCart,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    updateConfiguratedArticleInCart(cookie, cartItemId, configData, observe = 'body', reportProgress = false, options) {
      if (cookie === null || cookie === undefined) {
        throw new Error('Required parameter cookie was null or undefined when calling updateConfiguratedArticleInCart.');
      }
      if (cartItemId === null || cartItemId === undefined) {
        throw new Error('Required parameter cartItemId was null or undefined when calling updateConfiguratedArticleInCart.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/shoppingcart/configuration/${this.configuration.encodeParam({
        name: "cookie",
        value: cookie,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/${this.configuration.encodeParam({
        name: "cartItemId",
        value: cartItemId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}`;
      return this.httpClient.request('put', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: configData,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    updateProductInCart(cookie, cartItemId, shoppingCartItem, observe = 'body', reportProgress = false, options) {
      if (cookie === null || cookie === undefined) {
        throw new Error('Required parameter cookie was null or undefined when calling updateProductInCart.');
      }
      if (cartItemId === null || cartItemId === undefined) {
        throw new Error('Required parameter cartItemId was null or undefined when calling updateProductInCart.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/shoppingcart/${this.configuration.encodeParam({
        name: "cookie",
        value: cookie,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/${this.configuration.encodeParam({
        name: "cartItemId",
        value: cartItemId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}`;
      return this.httpClient.request('put', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: shoppingCartItem,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function ShoppingCartService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ShoppingCartService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ShopConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ShoppingCartService,
      factory: ShoppingCartService.ɵfac,
      providedIn: 'root'
    });
  }
  return ShoppingCartService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * ESD ShoppingApiGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 121.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let SitemapService = /*#__PURE__*/(() => {
  class SitemapService {
    httpClient;
    basePath = 'https://api.esders.de/shop/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ShopConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    getSitemap(language, observe = 'body', reportProgress = false, options) {
      if (language === null || language === undefined) {
        throw new Error('Required parameter language was null or undefined when calling getSitemap.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['text/plain', 'application/json', 'text/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/sitemap/${this.configuration.encodeParam({
        name: "language",
        value: language,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function SitemapService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SitemapService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ShopConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SitemapService,
      factory: SitemapService.ɵfac,
      providedIn: 'root'
    });
  }
  return SitemapService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * ESD ShoppingApiGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 121.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let VersionService = /*#__PURE__*/(() => {
  class VersionService {
    httpClient;
    basePath = 'https://api.esders.de/shop/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ShopConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    getVersionInfo(observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/version`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function VersionService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || VersionService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ShopConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: VersionService,
      factory: VersionService.ɵfac,
      providedIn: 'root'
    });
  }
  return VersionService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const APIS = [ArticleConfigurationService, BrochuresService, CatalogPhotoService, FeatureService, HompageSearchService, OrderService, ProductPageService, SalesArticleService, SalesOfferService, ShoppingCartService, SitemapService, VersionService];

/**
 * ESD ShoppingApiGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 121.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD ShoppingApiGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 121.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD ShoppingApiGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 121.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

var BaseHompageElasticIndex = /*#__PURE__*/function (BaseHompageElasticIndex) {
  BaseHompageElasticIndex.TypeEnum = {
    Product: 'Product',
    Blog: 'Blog'
  };
  return BaseHompageElasticIndex;
}(BaseHompageElasticIndex || {});
/**
 * ESD ShoppingApiGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 121.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var BasePosition = /*#__PURE__*/function (BasePosition) {
  BasePosition.PositionTypeEnum = {
    Article: 'Article',
    ExtraPosition: 'ExtraPosition',
    ServicePosition: 'ServicePosition'
  };
  return BasePosition;
}(BasePosition || {});
/**
 * ESD ShoppingApiGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 121.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD ShoppingApiGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 121.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

var Certificate = /*#__PURE__*/function (Certificate) {
  Certificate.CertificateTypEnum = {
    TestCertificate: 'TestCertificate',
    IncommingCertificate: 'IncommingCertificate',
    DguvV3: 'DGUV_V3',
    DAkkS: 'DAkkS',
    MeasUncert: 'MeasUncert'
  };
  Certificate.CertificateFormatEnum = {
    CertificateAgp: 'CertificateAGP',
    CertificateDefault: 'CertificateDefault',
    CertificateMu: 'CertificateMU'
  };
  return Certificate;
}(Certificate || {});
var DeliveryArticlePosition = /*#__PURE__*/function (DeliveryArticlePosition) {
  DeliveryArticlePosition.PositionTypeEnum = {
    Article: 'Article',
    ExtraPosition: 'ExtraPosition',
    ServicePosition: 'ServicePosition'
  };
  return DeliveryArticlePosition;
}(DeliveryArticlePosition || {});
var DeliveryExtraPosition = /*#__PURE__*/function (DeliveryExtraPosition) {
  DeliveryExtraPosition.PositionTypeEnum = {
    Article: 'Article',
    ExtraPosition: 'ExtraPosition',
    ServicePosition: 'ServicePosition'
  };
  return DeliveryExtraPosition;
}(DeliveryExtraPosition || {});
var DeliveryServicePosition = /*#__PURE__*/function (DeliveryServicePosition) {
  DeliveryServicePosition.PositionTypeEnum = {
    Article: 'Article',
    ExtraPosition: 'ExtraPosition',
    ServicePosition: 'ServicePosition'
  };
  return DeliveryServicePosition;
}(DeliveryServicePosition || {});
/**
 * ESD ShoppingApiGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 121.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD ShoppingApiGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 121.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD ShoppingApiGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 121.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

var OrderArticlePosition = /*#__PURE__*/function (OrderArticlePosition) {
  OrderArticlePosition.PositionTypeEnum = {
    Article: 'Article',
    ExtraPosition: 'ExtraPosition',
    ServicePosition: 'ServicePosition'
  };
  return OrderArticlePosition;
}(OrderArticlePosition || {});
var OrderExtraPosition = /*#__PURE__*/function (OrderExtraPosition) {
  OrderExtraPosition.PositionTypeEnum = {
    Article: 'Article',
    ExtraPosition: 'ExtraPosition',
    ServicePosition: 'ServicePosition'
  };
  return OrderExtraPosition;
}(OrderExtraPosition || {});
/**
 * ESD ShoppingApiGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 121.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

var OrderServicePosition = /*#__PURE__*/function (OrderServicePosition) {
  OrderServicePosition.PositionTypeEnum = {
    Article: 'Article',
    ExtraPosition: 'ExtraPosition',
    ServicePosition: 'ServicePosition'
  };
  return OrderServicePosition;
}(OrderServicePosition || {});
/**
 * ESD ShoppingApiGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 121.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD ShoppingApiGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 121.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

var Product = /*#__PURE__*/function (Product) {
  Product.ProductTypeEnum = {
    Article: 'Article',
    Extraposition: 'Extraposition'
  };
  Product.CertificateTypeEnum = {
    Default: 'Default',
    NoCertificateNoServicedate: 'NoCertificateNoServicedate',
    CertificateAndServicedateFromAbascal: 'CertificateAndServicedateFromAbascal',
    CertificateAndServicedateWithoutInput: 'CertificateAndServicedateWithoutInput',
    Unknown: 'Unknown'
  };
  return Product;
}(Product || {});
var ProductFeatureListProperties = /*#__PURE__*/function (ProductFeatureListProperties) {
  ProductFeatureListProperties.TypeEnum = {
    Int: 'Int',
    Float: 'Float',
    Bool: 'Bool',
    String: 'String'
  };
  return ProductFeatureListProperties;
}(ProductFeatureListProperties || {});
/**
 * ESD ShoppingApiGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 121.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD ShoppingApiGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 121.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var PropertySearch = /*#__PURE__*/function (PropertySearch) {
  PropertySearch.PropertyTypeEnum = {
    Int: 'Int',
    Float: 'Float',
    Bool: 'Bool',
    String: 'String'
  };
  return PropertySearch;
}(PropertySearch || {});
/**
 * ESD ShoppingApiGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 121.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD ShoppingApiGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 121.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

var ServiceProduct = /*#__PURE__*/function (ServiceProduct) {
  ServiceProduct.CertificateTypeEnum = {
    Default: 'Default',
    NoCertificateNoServicedate: 'NoCertificateNoServicedate',
    CertificateAndServicedateFromAbascal: 'CertificateAndServicedateFromAbascal',
    CertificateAndServicedateWithoutInput: 'CertificateAndServicedateWithoutInput',
    Unknown: 'Unknown'
  };
  return ServiceProduct;
}(ServiceProduct || {});
var ServiceProductArticle = /*#__PURE__*/function (ServiceProductArticle) {
  ServiceProductArticle.CertificateTypeEnum = {
    Default: 'Default',
    NoCertificateNoServicedate: 'NoCertificateNoServicedate',
    CertificateAndServicedateFromAbascal: 'CertificateAndServicedateFromAbascal',
    CertificateAndServicedateWithoutInput: 'CertificateAndServicedateWithoutInput',
    Unknown: 'Unknown'
  };
  return ServiceProductArticle;
}(ServiceProductArticle || {});
/**
 * ESD ShoppingApiGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 121.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * ESD ShoppingApiGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 121.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * ESD ShoppingApiGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 121.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * ESD ShoppingApiGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 121.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * ESD ShoppingApiGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 121.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
let ShopApiModule = /*#__PURE__*/(() => {
  class ShopApiModule {
    static forRoot(configurationFactory) {
      return {
        ngModule: ShopApiModule,
        providers: [{
          provide: ShopConfiguration,
          useFactory: configurationFactory
        }]
      };
    }
    constructor(parentModule, http) {
      if (parentModule) {
        throw new Error('ShopApiModule is already loaded. Import in your base AppModule only.');
      }
      if (!http) {
        throw new Error('You need to import the HttpClientModule in your AppModule! \n' + 'See also https://github.com/angular/angular/issues/20575');
      }
    }
    static ɵfac = function ShopApiModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ShopApiModule)(i0.ɵɵinject(ShopApiModule, 12), i0.ɵɵinject(i1.HttpClient, 8));
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ShopApiModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return ShopApiModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { APIS, ArticleConfigurationService, BASE_PATH, BaseHompageElasticIndex, BasePosition, BrochuresService, COLLECTION_FORMATS, CatalogPhotoService, Certificate, DeliveryArticlePosition, DeliveryExtraPosition, DeliveryServicePosition, FeatureService, HompageSearchService, OrderArticlePosition, OrderExtraPosition, OrderService, OrderServicePosition, Product, ProductFeatureListProperties, ProductPageService, PropertySearch, SalesArticleService, SalesOfferService, ServiceProduct, ServiceProductArticle, ShopApiModule, ShopConfiguration, ShoppingCartService, SitemapService, VersionService };
